var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37305 12C2.37305 17.51 6.88878 22 12.4304 22C17.9719 22 22.4877 17.51 22.4877 12C22.4877 6.49 17.9719 2 12.4304 2C6.88878 2 2.37305 6.49 2.37305 12ZM11.6962 7.94L15.2464 11.47C15.3973 11.62 15.4677 11.81 15.4677 12C15.4677 12.19 15.3973 12.38 15.2464 12.53L11.6962 16.06C11.4045 16.35 10.9218 16.35 10.6301 16.06C10.3384 15.77 10.3384 15.29 10.6301 15L13.6473 12L10.6301 9C10.3384 8.71 10.3384 8.23 10.6301 7.94C10.9218 7.65 11.3945 7.65 11.6962 7.94Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleDown);
export default __webpack_public_path__ + "static/media/arrow-circle-down.d3898efd439c596a4fbe5955d907066b.svg";
export { ForwardRef as ReactComponent };